import React, { useState, useEffect, useRef, Fragment } from "react";
import { useReactToPrint } from 'react-to-print';
import { Col, Container, Row, Card, Stack, Image, Table } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { Divider, Button, Accordion, Icon } from "semantic-ui-react";
import axios from "axios";
import Barcode from "react-barcode";
import logo from "../../assets/logo.png"
import logo_jne from "../../assets/jne_logo.png"
import html2canvas from 'html2canvas'
import html2pdf from 'html2pdf.js'

export const OrderDelivery = () => {
    const location = useLocation()
    const componentRef = useRef();
    const [idOrder, setIdOrder] = useState(null)
    const [idCustomer, setIdCustomer] = useState(null)
    const [order, setOrder] = useState(null)
    const [warehouseDetailData, setWarehouseDetailData] = useState({})
    const [warehouseDetailLoader, setWarehouseDetailLoader] = useState(true)
    const [resiData, setResiData] = useState({})
    const [hasResi, setHasResi] = useState(true)
    const [resiDataLoader, setResiDataLoader] = useState(true)
    const [activeIndex, setActiveIndex] = useState(null);
    const [downloadLoading, setDownloadLoading] = useState(false)
    const [printLoading, setPrintLoading] = useState(false)
    const [enableClick, setEnableClick] = useState(true)
    const [printResi, setPrintResi] = useState(null);
    const labelRefs = useRef({});

    let invNumber = `INV${location.state.id_order.slice(2, location.state.id_order.length)}`

    // const handlePrint = useReactToPrint({
    //     content: () => componentRef.current,
    // });

    const handlePrint = (resi) => {
        setPrintLoading(true)
        setPrintResi(resi);
        setTimeout(() => {
            handleReactToPrint();
        }, 100); // Wait for state to update (just in case)
        setPrintLoading(false)
    };

    const handleReactToPrint = useReactToPrint({
        content: () => labelRefs.current[printResi],
    });

    const handleAccordionClick = (index) => {
        if(enableClick) {
            setActiveIndex(activeIndex === index ? null : index);
        }
    };

    const capitalizeWords = (str) => {
        return str
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    const trimText = (text, max = 40) => {
        if (!text) return "";
        if (text.length <= max) return text;
        
        const trimmed = text.substring(0, max);
        const lastSpace = trimmed.lastIndexOf(" ");
        return trimmed.substring(0, lastSpace);
    };
    
    const getWarehouseDetail = async () => {
        await axios({
        method: "POST",
        // url: `${global.SRV}api_hoops/controler/cart.php/?index=22`,
        url: `${global.hoops_api}api_hoops/controler/cart.php/?index=22`,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': '9c98bn59db7ejn845qwe'
        },
        })
        .then((response) => { 
            if (response.data.state == 200) {
                let data = response.data.data
                console.log(data)
                setWarehouseDetailData(data)
            }
            setWarehouseDetailLoader(false)
        })
        .catch((error) => {
            console.log(error) 
            setWarehouseDetailLoader(false)
        })
    }

    useEffect(() => {
        getWarehouseDetail()    
    }, []);

    useEffect(() => {
        if(printLoading || downloadLoading) {
            setEnableClick(false)
        } else {
            setEnableClick(true)
        }
    }, [printLoading, downloadLoading]);

    const getResi = async (id_order) => {
        setResiDataLoader(true)
        await axios({
            method: "GET",
            url:`${global.SRV}api_hoops_cms/controler/order.php/?index=13&id_order=${id_order}`,
            headers: { 'Content-Type': 'text/plain' },
        })
            .then(res => {
                console.log(res.data.data)
                if (res.data.state === 200) {
                    setResiData(res.data.data)
                    console.log(res.data.data)
                }
                console.log(res.data.data)
                setResiDataLoader(false)
            })
    }

    useEffect(() => {
        getResi(location.state?.id_order)
    }, [location.state?.id_order]);

    useEffect(() => {
        if(!resiData == null || resiData.length === 0 ) {
            setHasResi(false)
        } else {
            setHasResi(true)
        }
    }, [resiData]);

    const loadImages = (container) => {
        const images = container.querySelectorAll("img");
        const promises = Array.from(images).map(img => {
          if (img.complete) return Promise.resolve();
          return new Promise(resolve => {
            img.onload = resolve;
            img.onerror = resolve; // resolve anyway to prevent hanging
          });
        });
        return Promise.all(promises);
    };
      
    const handleDownload = async (resi) => {
        setDownloadLoading(true);
    
        const element = document.getElementById(`label-${resi}`);
        if (!element) {
            setDownloadLoading(false);
            return;
        }
    
        // Wait for images to load
        await loadImages(element);
    
        // Options for A4 Portrait
        const opt = {
            margin: [1, 1, 0, 1], // top, left, bottom, right (in mm)
            filename: `Label-${resi}.pdf`,
            image: { type: 'jpeg', quality: 1 },
            html2canvas: {
                scale: 3,       // Higher scale = sharper PDF
                useCORS: true,
                scrollX: 0,
                scrollY: 0
            },
            jsPDF: {
                unit: 'mm',
                format: 'a4', // A4 format (portrait)
                orientation: 'portrait'
            }
        };
    
        await html2pdf().set(opt).from(element).save();
        setDownloadLoading(false);
    };
            
    

    // const handlePrint = (resi) => {
    //     setPrintLoading(true);
    //     const content = document.getElementById(`label-${resi}`);
    //     if (!content) return;
      
    //     const printWindow = window.open('', '_blank');
    //     const html = `
    //       <html>
    //         <head>
    //           <title>Print Label</title>
    //           <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" />
    //           <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/semantic-ui-css/semantic.min.css" />
    //           <style>
    //             html, body {
    //               margin: 0;
    //               padding: 0;
    //               font-family: Arial, sans-serif;
    //               -webkit-print-color-adjust: exact;
    //               print-color-adjust: exact;
    //               zoom: 0.75;
    //             }
    //             @media print {
    //               @page {
    //                 size: A5 portrait;
    //                 margin: 0;
    //               }
    //               body {
    //                 padding: 10mm;
    //                 box-sizing: border-box;
    //                 overflow: hidden;
    //               }
    //               #label-content {
    //                 max-height: 210mm;
    //                 overflow: hidden;
    //               }
    //             }
    //           </style>
    //         </head>
    //         <body>
    //           <div id="label-content">
    //             ${content.innerHTML}
    //           </div>
    //           <script>
    //             function waitForImages(callback) {
    //               const images = document.images;
    //               let loadedCount = 0;
    //               const total = images.length;
    //               if (total === 0) return callback();
      
    //               for (let i = 0; i < total; i++) {
    //                 if (images[i].complete) {
    //                   loadedCount++;
    //                   if (loadedCount === total) callback();
    //                 } else {
    //                   images[i].addEventListener('load', () => {
    //                     loadedCount++;
    //                     if (loadedCount === total) callback();
    //                   });
    //                   images[i].addEventListener('error', () => {
    //                     loadedCount++;
    //                     if (loadedCount === total) callback();
    //                   });
    //                 }
    //               }
    //             }
      
    //             window.onload = () => {
    //               waitForImages(() => {
    //                 window.print();
    //                 window.onafterprint = () => window.close();
    //               });
    //             };
    //           </script>
    //         </body>
    //       </html>
    //     `;
      
    //     printWindow.document.write(html);
    //     printWindow.document.close();
    //     setPrintLoading(false);
    // };      
               

    const getOrder = async (id_order, id_customer) => {
        const param = {
            id_order: id_order,
            id_customer: id_customer,
        }
        axios({
            method: "POST",
            url: `${global.SRV}api_hoops_cms/controler/order.php/?index=3`,
            headers: { 'Content-Type': 'text/plain' },
            data: param
        })
            .then(res => { console.log(res.data.data)
                if (res.data.state === 200) {
                    setOrder(res.data.data)
                }
            })
    }
   
    const PrintComponent = React.forwardRef((props, ref) => {
        const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        let orderDate = new Date(order.header.order_date)
        let dateFormated = orderDate.toLocaleDateString("en-US", options)
        let orderID = order.header.id_order
        let invNumber = `INV${orderID.slice(2, orderID.length)}`
       
        return (
            <Fragment>
                <div 
                    // ref={ref} 
                    style={{ /*paddingTop: 50 */ }}>
                    { !hasResi && (
                    <>
                    <div 
                        style={{
                            position:'absolute',
                            top:'16%',
                            left:'10%',
                            zIndex:'auto',
                            letterSpacing:'20px',
                            opacity:'0.1',
                            fontSize:'4em',
                            fontWeight:'bold',
                        }}
                    ><Image src={logo} height={250} width={350}/></div>
                    <Row className="ms-5">
                        <Col lg={12} className="border border-dark w-50">
                            <div>
                                <Row className="border-bottom border-dark">
                                    <Col sm={6} className="mt-2 mb-2">
                                        <Stack direction="horizontal" gap={2}>
                                            <Image src={logo} height={28} width={38}/>
                                            <div style={{fontSize: "1em", fontWeight: "700"}}>Hoops Indonesia</div>
                                        </Stack>
                                    </Col>
                                    <Col sm={6} className="mt-2 mb-2">
                                        <div className="text-end" style={{fontSize:'0.9em', paddingTop:'0.2em'}}>Delivery Label</div>
                                    </Col>
                                    
                                </Row>
                                <Row className="border-bottom border-dark">
                                    <Col className="text-center">
                                        <Barcode height={70} width={2.5} value={order.header.no_resi} fontSize={14} displayValue={false} marginBottom={1}/>
                                        <div style={{fontSize:'0.8em'}}>Booking Number: {order.header.no_resi}</div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={3} className="mt-3">
                                        <div><Image src={logo_jne} height={20} width={40}/></div>
                                        
                                    </Col>
                                    <Col sm={3} className="mt-3">
                                        <div style={{fontSize:'0.8em'}}>
                                            <div className="fw-bold" style={{lineHeight:'1.5em'}}>{order.header.name}</div>
                                            <div className="text-facebook fw-bold" style={{lineHeight:'1em'}}>{order.header.service_display}</div>
                                        </div>
                                    </Col>
                                    <Col sm={3} className="mt-3">
                                        <div style={{fontSize:'0.8em'}}>
                                            <div className="text-muted" style={{lineHeight:'1.5em'}}>Order Date</div>
                                            <div className="fw-bold" style={{lineHeight:'1em'}}>{order.header.date_create}</div>
                                        </div>
                                    </Col>
                                    <Col sm={3} className="mt-3 text-end">
                                        <div style={{fontSize:'0.8em'}}>
                                            <div className="text-muted" style={{lineHeight:'1.5em'}}>Invoice number</div>
                                            <div className="fw-bold" style={{lineHeight:'1em'}}>#{invNumber}</div>
                                        </div>
                                    </Col>
                                </Row>
                                {/* <Row>
                                    <Col sm={3}>
                                    </Col>
                                    <Col sm={5} className="mt-1">
                                        <div style={{fontSize:'0.8em'}}>
                                            <div className="text-muted" style={{lineHeight:'1.5em'}}>Shipping cost</div>
                                            <div className="fw-bold" style={{lineHeight:'1em'}}>{global.IDR.format(order.header.courier_cost)}</div>
                                        </div>
                                    </Col>
                                    <Col sm={4} className="mt-1">
                                        <div style={{fontSize:'0.8em'}}>
                                            <div className="text-muted" style={{lineHeight:'1.5em'}}>Weight</div>
                                            <div className="fw-bold" style={{lineHeight:'1em'}}>{order.header.total_weight} Kg</div>
                                        </div>
                                    </Col>
                                </Row> */}
                                <Row>
                                    <Col sm={3} className="mt-1">
                                        <div className="fw-bold" style={{fontSize:'0.8em'}}>Sent to</div>
                                    </Col>
                                    <Col sm={9} style={{fontSize:'0.8em'}} className="mt-1">
                                        <div className="fw-bold">{order.header.recipient}</div>
                                        <div style={{lineHeight:'1.2em'}}>({order.header.phone})</div>
                                        <div style={{lineHeight:'1.5em'}}>{order.header.address_detail} {order.header.address_detail_dua}</div>
                                        <div style={{lineHeight:'1.5em'}}>{order.header.sub_district}, {order.header.district}, {order.header.city}, {order.header.zip}</div>
                                    </Col>
                                </Row>
                                <Row className="border-bottom border-dark pb-2">
                                    <Col sm={3} className="mt-1">
                                        <div className="fw-bold" style={{fontSize:'0.8em'}}>From</div>
                                    </Col>
                                    <Col sm={9} className="mt-1" style={{fontSize:'0.8em'}}>
                                        <div className="fw-bold">Hoops Indonesia</div>
                                        <div style={{lineHeight:'1.2em'}}>Jl. Surapati No.61, Sadang Serang, Coblong,</div>
                                        <div style={{lineHeight:'1.5em'}}>Bandung, Jawa Barat</div>
                                    </Col>
                                </Row>
                                <Row className="border-bottom border-dark pb-2">
                                    <Col>
                                        <Table style={{fontSize:'12px'}}>
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Product</th>
                                                    <th>Qty</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    order.detail.map((o,i) => 
                                                        <tr>
                                                            <td>{i+1}</td>
                                                            <td>
                                                                <Stack direction="horizontal" gap={2}>
                                                                    <Image src={o.image} height={40} width={46} rounded className="border"/>
                                                                    <Stack direction="vertical" gap={0} style={{lineHeight:1.1}}>
                                                                        <div className="fw-bold">{o.item_name}</div>
                                                                        <div>{o.id_product}</div>
                                                                        <div>Size : {o.size}</div>
                                                                    </Stack>
                                                                </Stack>
                                                            </td>
                                                            <td>
                                                                <b className={o.qty > 1 ? "text-danger" : "text-primary"}>
                                                                    {o.qty}
                                                                </b>
                                                            </td>
                                                        </tr>
                                                    )
                                                }
                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12} className="mt-1 mb-2">
                                        <div className="fw-bold" style={{fontSize:'0.8em'}}>The booking code above cannot be tracked yet</div>
                                        <div style={{fontSize:'0.8em'}}>
                                            <div style={{lineHeight:'1.2em'}}>
                                                Booking number has not been verified by the system. It cannot be tracked yet, until the courier agent verifies it in their system.
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                    </>
                    )}
                    {resiDataLoader && <label>Memuat Detail, Mohon Tunggu...</label>}
                    {hasResi && resiData && !resiDataLoader && (
                        <Accordion fluid>
                            { Object.entries(
                                resiData.reduce((acc, item) => {
                                    const key = item.id_warehouse;
                                    if (!acc[key]) acc[key] = [];
                                    acc[key].push(item);
                                    return acc;
                                }, {})
                            )
                            .sort(([a], [b]) => {
                                if (a === 'WH0006') return -1;
                                if (b === 'WH0006') return 1;
                                return a.localeCompare(b);
                            })
                            .map(([warehouseId, items], groupIndex) => {
                                const item = items[0];
                                const isActive = activeIndex === groupIndex;
                                return (
                                    <>
                                        <Accordion.Title
                                            active={isActive}
                                            index={groupIndex}
                                            onClick={() => handleAccordionClick(groupIndex)}
                                            style={{
                                                cursor: 'pointer',
                                                fontSize: '1.1rem',
                                                padding: '0.75rem 0',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '0.5rem',
                                            }}
                                        >
                                            <Icon name={isActive ? 'angle down' : 'angle right'} color="orange" />
                                            <span style={{ fontWeight: 'bold' }}>
                                                {warehouseDetailData[warehouseId]?.name}: <span style={{ color: 'orange' }}>{item.no_resi}</span>
                                            </span>
                                        </Accordion.Title>
                                        <Accordion.Content active={isActive}>
                                            <Row className="justify-content-end mb-2">
                                                <Col xs="auto">
                                                    <Button color="blue" size="small" disabled={!enableClick} loading={downloadLoading} onClick={() => handleDownload(item.no_resi)}>
                                                    <Icon name="download" /> Download
                                                    </Button>
                                                    <Button color="orange" size="small" disabled={!enableClick} loading={printLoading} className="ms-2" onClick={() => handlePrint(item.no_resi)}>
                                                    <Icon name="print" /> Print
                                                    </Button>
                                                </Col>
                                            </Row>
                                            {/* <div
                                                id={`label-${item.no_resi}`}
                                                ref={(el) => {
                                                    if (el) labelRefs.current[item.no_resi] = el;
                                                }}
                                                style={{
                                                    position: 'relative',
                                                    padding: '1rem',
                                                    // backgroundColor: 'white', // ensures the table remains readable
                                                }}
                                            > */}
                                                {/* <div
                                                    style={{
                                                    position: 'absolute',
                                                    top: '10rem',
                                                    left: '2rem',
                                                    width: '300px',
                                                    height: '300px',
                                                    backgroundImage: `url(${logo})`,
                                                    backgroundRepeat: 'no-repeat',
                                                    backgroundSize: 'contain',
                                                    opacity: 0.1,
                                                    zIndex: 'auto',
                                                    }}
                                                /> */}
                                                {/* <table className="table table-bordered w-100" style={{ fontSize: '0.85rem', position: 'relative', zIndex: 1 }}>
                                                    <thead>
                                                    <tr>
                                                        <th colSpan="2" className="text-start">
                                                        <div className="d-flex align-items-center gap-2">
                                                            <Image src={logo} height={28} width={38} />
                                                            <strong>Hoops Indonesia</strong>
                                                        </div>
                                                        </th>
                                                        <th colSpan="2" className="text-end">Delivery Label</th>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan="4" className="text-center">
                                                        <Barcode height={70} width={2.5} value={item.no_resi} fontSize={14} displayValue={false} />
                                                        <div>Booking Number: {item.no_resi}</div>
                                                        </td>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr className="text-center">
                                                        <td>
                                                            <Image src={item.logo} height={20} width={40} />
                                                        </td>
                                                        <td>
                                                            <strong>{item.courier_name}</strong><br />
                                                            <span className="text-facebook">{item.service_display}</span>
                                                        </td>
                                                        <td>
                                                            <div className="text-muted">Order Date</div>
                                                            <strong>{order.header.date_create}</strong>
                                                        </td>
                                                        <td>
                                                            <div className="text-muted">Invoice number</div>
                                                            <strong>#{invNumber}</strong>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-center"><strong>Sent to</strong></td>
                                                        <td colSpan="3">
                                                        <strong>{order.header.recipient}</strong><br />
                                                        ({order.header.phone})<br />
                                                        {order.header.address_detail} {order.header.address_detail_dua}<br />
                                                        {order.header.sub_district}, {order.header.district}, {order.header.city}, {order.header.zip}
                                                        </td>
                                                    </tr>
                                                    {!warehouseDetailLoader && (
                                                        <tr>
                                                        <td className="text-center"><strong>From</strong></td>
                                                        <td colSpan="3">
                                                            <strong>{capitalizeWords(trimText(warehouseDetailData[warehouseId]?.name))} ({warehouseDetailData[warehouseId]?.alias})</strong><br />
                                                            {capitalizeWords(trimText(warehouseDetailData[warehouseId]?.address))}, {capitalizeWords(trimText(warehouseDetailData[warehouseId]?.region))}<br />
                                                            {capitalizeWords(warehouseDetailData[warehouseId]?.city)}, {capitalizeWords(warehouseDetailData[warehouseId]?.prov)}
                                                        </td>
                                                        </tr>
                                                    )}
                                                    <tr>
                                                        <td colSpan="4">
                                                        <table className="table table-sm table-bordered mb-0" style={{ fontSize: '0.75rem' }}>
                                                            <thead>
                                                            <tr className="text-center">
                                                                <th>#</th>
                                                                <th>Product</th>
                                                                <th>Qty</th>
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            {order.detail
                                                                .filter(o => o.id_warehouse === warehouseId)
                                                                .map((o, i) => (
                                                                <tr key={i}>
                                                                    <td className="text-center">{i + 1}</td>
                                                                    <td>
                                                                    <div className="d-flex gap-2 align-items-center">
                                                                        <Image src={o.image} height={40} width={46} className="border" />
                                                                        <div>
                                                                        <strong>{o.item_name}</strong><br />
                                                                        {o.id_product}<br />
                                                                        Size: {o.size}
                                                                        </div>
                                                                    </div>
                                                                    </td>
                                                                    <td className="text-center">{o.qty}</td>
                                                                </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan="4">
                                                        <strong>The booking code above cannot be tracked yet</strong><br />
                                                        Booking number has not been verified by the system. It cannot be tracked yet, until the courier agent verifies it in their system.
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div> */}
                                                <Row
                                                    key={groupIndex}
                                                    id={`label-${item.no_resi}`}
                                                    ref={(el) => {
                                                        if (el) labelRefs.current[item.no_resi] = el;
                                                    }}
                                                    className="w-100 ms-5"
                                                    style={{
                                                        // width: '148mm',
                                                        // height: '105mm',
                                                        // padding: '5mm',
                                                        // boxSizing: 'border-box',
                                                        // margin: 'auto',
                                                        // border: '1px solid #000',
                                                        // display: 'flex',
                                                        // flexDirection: 'column',
                                                        // justifyContent: 'space-between',
                                                        // backgroundColor: 'white'
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                        position: 'absolute',
                                                        top: '10rem',
                                                        left: '5rem',
                                                        width: '300px',
                                                        height: '300px',
                                                        backgroundImage: `url(${logo})`,
                                                        backgroundRepeat: 'no-repeat',
                                                        backgroundSize: 'contain',
                                                        opacity: 0.1,
                                                        zIndex: 'auto',
                                                        }}
                                                    />
                                                    <Col lg={12} className="border border-dark w-50 mt-2" style={{ overflowX: 'auto' }}>
                                                        <div>
                                                            <Row className="border-bottom border-dark">
                                                                <Col sm={6} className="mt-2 mb-2">
                                                                    <Stack direction="horizontal" gap={2}>
                                                                        <Image src={logo} height={28} width={38} />
                                                                        <div className="fw-bold" style={{ fontSize: '1em' }}>Hoops Indonesia</div>
                                                                    </Stack>
                                                                </Col>
                                                                <Col sm={6} className="mt-2 mb-2 text-end">
                                                                    <div style={{ fontSize: '1.2em', paddingTop: '0.2em' }}>Delivery Label</div>
                                                                </Col>
                                                            </Row>
                                                            <Row className="border-bottom border-dark py-2">
                                                                <Col className="text-center">
                                                                    <Barcode height={50} width={2} value={item.no_resi} fontSize={9} displayValue={false} marginBottom={1}/>
                                                                    
                                                                    {/*
                                                                    <Barcode height={50} width={2.35} format="CODE128B" textMargin={10} value={item.no_resi} fontSize={5} displayValue={false} marginBottom={1}/>
                                                                    */}

                                                                    <div className="fw-bold" style={{ fontSize: '0.85em' }}>BOOKING NUMBER : {item.no_resi}</div>
                                                                </Col>
                                                            </Row>

                                                            <Row>
                                                                <Col sm={3} className="mt-3">
                                                                    <Image src={item.logo} height={40} width={60} />
                                                                </Col>
                                                                <Col sm={3} className="mt-3" style={{ fontSize: '0.85em' }}>
                                                                    <div className="fw-bold">{item.courier_name}</div>
                                                                    <div className="text-facebook fw-bold">{item.service_display} ({item.weight} KG)</div>
                                                                </Col>
                                                                <Col sm={3} className="mt-3" style={{ fontSize: '0.85em' }}>
                                                                    <div className="text-muted">ORDER DATE</div>
                                                                    <div className="fw-bold">{order.header.date_create}</div>
                                                                </Col>
                                                                <Col sm={3} className="mt-3 text-end" style={{ fontSize: '0.85em' }}>
                                                                    <div className="text-muted">INVOICE NUMBER</div>
                                                                    <div className="fw-bold">#{invNumber}</div>
                                                                </Col>
                                                            </Row>

                                                            <Row className="mt-3">
                                                                <Col sm={3} className="mt-1">
                                                                    <div className="fw-bold" style={{ fontSize: '0.85em' }}>SENT TO</div>
                                                                </Col>
                                                                <Col sm={9} className="mt-1" style={{ fontSize: '0.85em' }}>
                                                                    <div className="fw-bold">{order?.header?.recipient?.toUpperCase() ?? "-"} ({order.header.phone})</div>
                                                                    <div>{order.header.address_detail} {order.header.address_detail_dua}, {order.header.sub_district}, {order.header.district} </div>
                                                                    <div>{order.header.city}, {order.header.zip}</div>
                                                                </Col>
                                                            </Row>
                                                            {warehouseDetailLoader ? (
                                                                <Row className="border-bottom border-dark pb-2">
                                                                    <Col sm={3} className="mt-1">
                                                                        <div className="fw-bold" style={{ fontSize: '0.85em' }}>Loading Warehouse Data...</div>
                                                                    </Col>
                                                                </Row>
                                                            ) : (
                                                            <Row className="border-bottom border-dark pb-2">
                                                                <Col sm={3} className="mt-1">
                                                                    <div className="fw-bold" style={{ fontSize: '0.85em' }}>FROM</div>
                                                                </Col>
                                                                <Col sm={9} className="mt-1" style={{ fontSize: '0.85em' }}>
                                                                    <div className="fw-bold">
                                                                        {/* {`Warehouse: ${capitalizeWords(warehouseDetailData[warehouseId]?.name)} (${warehouseDetailData[warehouseId]?.alias})`} */}
                                                                        {`WAREHOUSE: ${warehouseDetailData[warehouseId]?.name?.toUpperCase() ?? "-"} (${warehouseDetailData[warehouseId]?.alias})`}
                                                                    </div>
                                                                    <div>
                                                                        {/* {`${capitalizeWords(trimText(warehouseDetailData[warehouseId]?.address))}, 
                                                                        ${capitalizeWords(trimText(warehouseDetailData[warehouseId]?.region))}, `}
                                                                        {`${capitalizeWords(warehouseDetailData[warehouseId]?.city)}, ${capitalizeWords(warehouseDetailData[warehouseId]?.prov)}`} */}
                                                                        {`${warehouseDetailData[warehouseId]?.address}, 
                                                                        ${warehouseDetailData[warehouseId]?.region}, `}
                                                                        {`${warehouseDetailData[warehouseId]?.city}, ${warehouseDetailData[warehouseId]?.prov}`}
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                            )}
                                                            <Row className="border-bottom border-dark pb-2">
                                                                <Col>
                                                                    <Table style={{ fontSize: '11px' }}>
                                                                        <thead>
                                                                            <tr>
                                                                                <th>#</th>
                                                                                <th>PRODUCT</th>
                                                                                <th>QTY</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                        {order.detail
                                                                            .filter(o => o.id_warehouse === warehouseId)
                                                                            .map((o, i) => (
                                                                                <tr key={i}>
                                                                                <td className="text-center">{i + 1}</td>
                                                                                <td>
                                                                                    <Stack direction="horizontal" gap={2}>
                                                                                    <Image src={o.image} height={40} width={46} rounded className="border" />
                                                                                    <Stack direction="vertical" gap={0} style={{ lineHeight: 1.1 }}>
                                                                                        <div className="fw-bold">{o.item_name}</div>
                                                                                        <div>{o.id_product}</div>
                                                                                        <div>Size: {o.size}</div>
                                                                                    </Stack>
                                                                                    </Stack>
                                                                                </td>
                                                                                <td className="text-center">
                                                                                    <b className={o.qty > 1 ? "text-danger" : "text-primary"}>
                                                                                        {o.qty}
                                                                                    </b>
                                                                                </td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </Table>
                                                                </Col>
                                                            </Row>
                                                            {/* <Row>
                                                                <Col md={12} className="mt-1 mb-2" style={{ fontSize: '0.5em' }}>
                                                                    <div className="fw-bold">The booking code above cannot be tracked yet</div>
                                                                    <div>
                                                                        Booking number has not been verified by the system. It cannot be tracked yet, until the courier agent verifies it in their system.
                                                                    </div>
                                                                </Col>
                                                            </Row> */}
                                                        </div>
                                                    </Col>
                                                </Row>
                                            {/* </div> */}
                                        </Accordion.Content>
                                    </>
                                );
                            })}
                        </Accordion>
                    )}
                </div>
            </Fragment>
        )
    })

    useEffect(() => {
        setIdOrder(location.state.id_order)
        setIdCustomer(location.state.id_customer)
        getOrder(location.state.id_order, location.state.id_customer)
    }, [location.state])

    return (
        <Container fluid>
            <Row className="mt-1 mb-3">
                <div className="text-facebook h3 mb-0">Shipping Label</div>
                <div className="text-muted">This is shipping label for order #{location.state.id_order}</div>
            </Row>
            <Divider />
            {/* <Row className="mb-3">
                <Col lg={6}>

                </Col>
                <Col lg={6} className='d-flex justify-content-end'>
                    <Button content="Print" icon="print" onClick={handlePrintOld} />
                </Col>
            </Row> */}
            {
                order ?
                    <PrintComponent data={order} />
                    : <>Loading...</>
            }
        </Container>
    )
}
